import styled from "styled-components";

export const Container = styled.div`
  background: rgba(0, 0, 0, 0.15);
  width: 120px;
  height: 75px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Image = styled.img`
  width: 120px;
  height: 75px;
`;
